import React, { FC } from 'react';
import { Autocomplete, TextField, Chip, MenuItem } from '@mui/material';

/* eslint-disable @typescript-eslint/no-explicit-any */
interface GradeSelectProps {
  tComp: (key: string) => string;
  allDMSchoolGrades: string[];
  selectedDMSchoolGrades: string[];
  autocompleteItemStyle: (selected: boolean) => any;
  handleDMSchoolGradesChanged: (grades: string[]) => void;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const GradeSelect: FC<GradeSelectProps> = ({
  tComp,
  allDMSchoolGrades,
  selectedDMSchoolGrades,
  autocompleteItemStyle,
  handleDMSchoolGradesChanged,
}) => {
  return (
    <Autocomplete
      multiple
      options={allDMSchoolGrades}
      getOptionLabel={(option) => tComp(`DMBlock.School.Grades.Options.${option}`)}
      value={selectedDMSchoolGrades}
      onChange={(_, v) => handleDMSchoolGradesChanged(v)}
      renderInput={(params) => (
        <TextField {...params} label={tComp('DMBlock.School.Grades.SelectGrade')} size='small' />
      )}
      renderValue={(value: string[], getItemProps) =>
        value.map((option: string, index: number) => (
          <Chip
            size='small'
            {...getItemProps({ index })}
            key={option}
            label={tComp(`DMBlock.School.Grades.Options.${option}`)}
          />
        ))
      }
      renderOption={(props, option, { selected }) => (
        <li {...props} style={autocompleteItemStyle(selected)}>
          {tComp(`DMBlock.School.Grades.Options.${option}`)}
        </li>
      )}
      fullWidth
      disableCloseOnSelect
    />
  );
};

export default GradeSelect;
